import clsx from "clsx";
import { FC, ReactNode, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { RichLogSorting } from "@ryde/shared";

import { IRichLogsFilter, RichLogFormFields } from "./rich-logs.models";
import { richLogSortingOptions } from "./rich-logs.utils";

export const RichLogSortDropdown: FC = () => {
  const { control } = useFormContext<IRichLogsFilter>();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (): void => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (): void => {
    setIsOpen(false);
  };

  const getSortIcon = (sortType: RichLogSorting): ReactNode => {
    switch (sortType) {
      case RichLogSorting.ByTimeAscending:
        return <PIC.TableSortAscSVG />;
      case RichLogSorting.ByTimeDescending:
        return <PIC.TableSortDescSVG />;
      default:
        return null;
    }
  };

  return (
    <Controller
      name={RichLogFormFields.sort}
      control={control}
      render={({ field }) => (
        <div className="log__filters-sort-dropdown log__filters-sort-dropdown--sort">
          <div className="log__filters-sort-row">
            <label className="log__filters-sort-label">
              {t("rideProduction.formLabel.sort")}
            </label>
            <div className="log__filters-sort-container">
              <button
                type="button"
                className="log__filters-sort-button"
                onClick={handleToggle}
              >
                <div className="log__filters-sort-content">
                  {getSortIcon(field.value as RichLogSorting)}
                  <span className="log__filters-sort-value">
                    {richLogSortingOptions.find(
                      option => option.value === field.value,
                    )?.label || field.value}
                  </span>
                </div>
                <span
                  className={clsx("log__filters-sort-arrow", {
                    open: isOpen,
                  })}
                >
                  ▼
                </span>
              </button>

              {isOpen && (
                <div className="log__filters-sort-dropdown-menu">
                  {richLogSortingOptions.map(option => (
                    <button
                      key={option.value}
                      type="button"
                      className={clsx("log__filters-sort-option", {
                        selected: field.value === option.value,
                      })}
                      onClick={() => {
                        field.onChange(option.value);
                        handleSelect();
                      }}
                    >
                      <div className="log__filters-sort-option-content">
                        {getSortIcon(option.value as RichLogSorting)}
                        <span>{option.label}</span>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    />
  );
};
